import { reachGoal } from "../components/YaMetrika";
import buildLink from "../utils/buildLink";

export default class BaseEventHandler {
    _getDefaultParams(context) {
        let fpr = context.fpr;

        if (context.fprVersion) {
            fpr = `${fpr}_${context.fprVersion}`;
        }

        const params = { fpr };

        if (context.isFull) {
            params.isFull = "yes";
        } else {
            params.isPrv = "yes";
        }

        return params;
    }

    _getParams(context, params) {
        return Object.assign(this._getDefaultParams(context), params);
    }

    _isFromPreview(context) {
        return context.queryString.from == "preview";
    }

    _isFromRecommendation(context) {
        //const tags = ["recommendation", "bottom_next_news", "header_next_news"];
        //return tags.indexOf(context.queryString.from) != -1;
        return context.queryString.from && context.queryString.from.indexOf("recommendation") == 0;
    }

    _getRecommendationTag(context) {
        return context.queryString.from.replace("recommendation_", "");
    }

    _isRefresh(context) {
        return context.queryString.refresh == "yes";
    }

    _getFrom(context) {
        if (this._isFromPreview(context)) {
            return "preview";
        } else if (this._isFromRecommendation(context)) {
            return "recommendation";
        } else {
            return "direct";
        }
    }

    _onFullMount(context) {
        const params = this._getParams(context, {
            from: this._getFrom(context),
            refresh: this._isRefresh(context),
        });

        if (params.from == "recommendation") {
            params.block_tag = this._getRecommendationTag(context);
        }

        reachGoal("in_news", params);
    }

    _onPreviewMount(context) {
        const params = this._getDefaultParams(context);
        reachGoal("in_preview", params);
    }

    _reloadCallback(context, url, timeout) {
        return function () {
            setTimeout(function () {
                if (url) {
                    document.location = buildLink(context, url, { refresh: "yes" });
                }
            }, timeout);
        };
    }

    _onTeaserClick(target, context, props, extraParams) {
        console.log("_onTeaserClick");

        const { block_tag, teaser } = props;

        const params = this._getParams(context, {
            refresh: this._isRefresh(context),
        });

        if (context.isFull) {
            params.from = this._getFrom(context);
        }

        if (block_tag) {
            params.block_tag = block_tag;
        }

        if (teaser && teaser.scrollNum != undefined) {
            params.scrollNum = teaser.scrollNum + 1;
        }

        Object.assign(params, extraParams);

        reachGoal(target, params);
    }

    onCoreMount(context) {
        console.log("onCoreMount");

        if (context.isFull) {
            this._onFullMount(context);
        } else {
            this._onPreviewMount(context);
        }

        if (context.reload_page) {
            setTimeout(() => {
                const href = window.location.href.replace(window.location.search, "");
                window.location.href = buildLink(context, href, { reload_page: true });
            }, context.reload_page_timeout);
        }
    }

    onNewsClick(context, props) {
        console.log("onNewsClick", props);

        const params = this._getParams(context, {
            refresh: this._isRefresh(context),
        });

        const rcb = this._reloadCallback(context, props.redirect, 500);
        const rcb2 = this._reloadCallback(context, props.redirect, 5000);
        reachGoal("out_main", params, rcb);
        rcb2();
    }

    onTeaserClick(context, props) {
        console.log("onTeaserClick");

        const params = {};

        let block_position = props.teaser.index + 1;
        if (props.teaser.scrollNum != undefined) {
            block_position = `${props.teaser.scrollNum + 1}_${block_position}`;
        }

        let fullFpr = context.fpr;
        if (context.fprVersion) {
            fullFpr = `${fullFpr}_${context.fprVersion}`;
        }
        const posKey = `${fullFpr}_block_${props.teaser.object}_position`;

        if (context.isFull) {
            params[posKey] = block_position;
        } else {
            params[posKey] = block_position;
        }

        const target = context.isFull ? "full_teaser_click" : "prv_teaser_click";

        this._onTeaserClick(target, context, props, params);
    }

    onRecommendationClick(context, props) {
        console.log("onRecommendationClick");
        this._onTeaserClick("recommendation_teaser_click", context, props);
    }

    onScrollLoad(context, scrollNum) {
        console.log("onScrollLoad");

        let target;

        if (scrollNum <= 3) {
            target = `load_${scrollNum + 1}`;
        } else {
            target = "load_other";
        }

        reachGoal(target, this._getDefaultParams(context));
    }

    onBlockMount(context, props) {
        console.log("onBlockMount");
    }

    onCategoryClick(context, props) {
        console.log("onCategoryClick");
        this.onInternalClick(context, { block_tag: "category" });
    }

    onInternalClick(context, props) {
        console.log("onInternalClick");

        const { block_tag } = props;
        const params = {};

        if (block_tag) {
            params.block_tag = block_tag;
        }

        reachGoal("internal_click", params);
    }
}
